import React, { memo } from 'react'

import { Skeleton } from '@fourthwall/components'

import * as S from './styled'

export const OptionsSkeleton = memo(() => (
  <Skeleton>
    <S.List>
      <S.Item>
        <Skeleton.Shape width="60%" height={16} />
        <Skeleton.Shape width="15%" height={12} />
      </S.Item>
      <S.Item>
        <Skeleton.Shape width="70%" height={16} />
        <Skeleton.Shape width="20%" height={12} />
      </S.Item>
      <S.Item>
        <Skeleton.Shape width="65%" height={16} />
        <Skeleton.Shape width="25%" height={12} />
      </S.Item>
    </S.List>
  </Skeleton>
))
